export class TermsAndConditionsResponse {
  public title: string;
  public body: string;
}
